import React from 'react';
import AdminAnalytics from './adminAnalytics';
import MerchantAnalytics from './MerchantAnalytics/MerchantAnalytics';
import ManagerAnalytics from './ManagerAnalytics';
import StaffAnalytics from './StaffAnalytics';

const Analytics = ({ role }) => {
  return (
    <div>
      {role === 'admin' && <AdminAnalytics />}
      {role === 'merchant' && <MerchantAnalytics role={role} />}
      {role === 'manager' && <ManagerAnalytics />}
      {role === 'staff' && <StaffAnalytics />}
    </div>
  );
};

export default Analytics;
